<template>
  <div class="imgBox">
    <div class="wrap">
      <div @mouseover="mouseover()" @mouseout="mouseout()" @click="showOptionList()">
        <img class="init-img icon" :src="imgSrc" alt="" v-show="!isActive" />
        <img class="init-img icon" :src="activeImg" alt="" v-show="isActive" />
      </div>
      <span>{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: {
      type: String,
      default: '',
    },
    activeImg: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    img() {
      return ''
    },
  },
  data() {
    return {
      isActive: false,
      isOptionList: false,
    }
  },
  methods: {
    mouseover() {
      this.isActive = true
    },
    mouseout() {
      this.isActive = false
    },
    showOptionList() {
      this.isOptionList = true
    },
  },
}
</script>

<style lang="less" scoped>
.imgBox {
  position: relative;
  .wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.icon {
  width: 14vh;
  cursor: pointer;
}
</style>
